import apiUrl from '../../../../../utils/settings';

export const LinkedManufacturesUrl = () => {
  return apiUrl + '/benefits-v2/active-manufacturer-companies';
};
export const OverviewDetailsUrl = () => {
  return apiUrl + '/benefits-v2/humbee-benefits';
};

export const MyBenefitsUrl = () => {
  return apiUrl + '/benefits-v2/my-benefits';
};
